var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('iframe',{staticStyle:{"height":"542px","width":"100%"},attrs:{"id":"ifpaybill","name":"ifpaybill","src":"https://bill-sb.payoo.vn/embed/mng/20535","frameborder":"0","scrolling":"no"}})}
var staticRenderFns = []

export { render, staticRenderFns }